import React from 'react';
import PropTypes from 'prop-types';
import { Button as RsButton, Spinner } from 'reactstrap';
import classnames from 'classnames';

const Button = ({ children, loading, block, ...rest }) => (
  <RsButton {...rest} block={block}>
    {!(block && !loading) && (
      <Spinner
        className={classnames({
          'position-relative': true,
          'button-style': !block,
          visible: loading,
          invisible: !loading,
        })}
        size="sm"
        // type="grow"
      />
    )}
    {!(block && loading) && (
      <span
        className={classnames({
          invisible: loading,
          visible: !loading,
          'span-style': !block,
        })}
      >
        {children}
      </span>
    )}
  </RsButton>
);

Button.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  block: PropTypes.bool,
};

export default Button;
